<template>
  <v-card>
    <v-form>
      <v-container>
        <fieldset>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">UserName</label>
              <v-text-field v-model="username" label="Name" :error-messages="errors.username" placeholder="Name" solo>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Full Name</label>
              <v-text-field v-model="currentName" label="Name" placeholder="Name" solo :error-messages="errors.name">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Email</label>
              <v-text-field v-model="currentEmail" type="email" label="Email" placeholder="Email" solo
                :error-messages="errors.email"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Password</label>
              <v-text-field v-model="currentPassword" type="password" label="Password" placeholder="Password" solo
                :error-messages="errors.password"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" v-if="selectedRole != 'Admin'">
              <label class="custom-label">Status</label>
              <v-select v-model="selectStatus" :items="statuses" label="Choose Status" placeholder="Choose Status" solo
                :error-messages="errors.status"></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Role</label>
              <v-select v-model="selectedRole" :items="roles" label="Choose Role" placeholder="Choose Role" solo
                :error-messages="errors.role"></v-select>
            </v-col>
            <v-col cols="12">
              <v-btn color="#6A158E" dark @click="save">Save</v-btn>
            </v-col>
          </v-row>
        </fieldset>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import Form from "../../utils/form/Form";
export default {
  name: "UserForm",
  props: {
    id: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      username: "",
      currentName: "",
      currentEmail: "",
      currentPassword: "",
      selectStatus: "",
      selectedRole: "",
      statuses: [{ text: "Active", value: 'active' }, { text: "InActive", value: 'inactive' }],
      roles: [],

      errors: {},

    };

  },
  methods: {
    save() {
      if (this.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      axios({
        method: 'post',
        url: apiRoutes.users.url,
        data: {
          name: this.currentName,
          username: this.username,
          email: this.currentEmail,
          is_active: true,
          status: this.selectStatus,
          role: this.selectedRole,
          is_staff: true,
          password: this.currentPassword
        }
      })
        .then((response) => {
          // console.log(response)
          this.$router.replace({ name: 'Users' })
        })
        .catch(error => {
          // console.log(error)
          if (error.response.status === 400) {
            this.errors = error.response.data
          }
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;

          }
          this.loading = false
        });
    },
    update() {
      let data = {
        name: this.currentName,
        username: this.username,
        email: this.currentEmail,
        is_active: true,
        status: this.selectStatus,
        role: this.selectedRole,
        is_staff: true,
      }
      if (this.currentPassword != null && this.currentPassword != "") {
        data.password = this.currentPassword
      }
      axios.patch(apiRoutes.users.url + '/' + this.id, data).then(response => {
        this.errors = {}
        this.loading = false
        this.$router.replace({ name: 'Users' })
      }).catch(error => {
        if (error.response.status === 400) {
          this.errors = error.response.data
        }
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;

        }
        this.loading = false
      })
    },
    getRoles(){
      axios.get(apiRoutes.roles.getRoles)
      .then(res => {
        let roles = [];
        res?.data?.map(item => {
          roles.push({text: item.display_name, value: item.display_name})
        })
          this.roles = roles;
      }).catch(err => {
        console.log(err,'err');
      })
    }
  },
  mounted() {
    this.loading = false
    this.getRoles();
    if (this.id) {
      this.loading = true
      axios.get(apiRoutes.users.url + '/' + this.id).then(response => {
        console.log(response)
        this.currentEmail = response.data.email
        this.currentName = response.data.name
        this.selectStatus = response.data.status
        this.username = response.data.username
        this.selectedRole = response.data.user_role
        this.loading = false
      })
    }
  }
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }

  & label {
    font: Bold 15px/40px Lato;
    color: #172b4d;
  }
}
</style>